import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq, fluidSpace, fluidHeight } from '@/theme/scalingTokens';

export const useHomeHeroStyles = makeStyles({
  root: {
    position: 'relative',
    width: '100%',
    minHeight: '280px',
    height: fluidHeight.bannerMd,
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    backgroundColor: tokens.colorBrandBackground,
    overflow: 'hidden',
    [mq.ultraWideUp]: {
      height: fluidHeight.bannerLg,
    },
  },

  overlay: {
    position: 'absolute',
    top: '48px',
    left: '48px',
    ...shorthands.padding('24px'),
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap('16px'),
    '::before': {
      content: '""',
      position: 'absolute',
      inset: '0',
      backgroundColor: tokens.colorBrandBackground,
      opacity: 0.85,
      ...shorthands.borderRadius('inherit'),
    },
    '& > *': { position: 'relative' },
    [mq.tablet]: {
      top: '24px',
      left: '24px',
      right: '24px',
    },
    [mq.mobile]: {
      top: '16px',
      left: '16px',
      right: '16px',
      ...shorthands.padding('16px'),
    },
    [mq.ultraWideUp]: {
      top: 'clamp(48px, 3.5vw, 72px)',
      left: 'clamp(48px, 3.5vw, 72px)',
      ...shorthands.padding(fluidSpace.xxl),
      ...shorthands.gap('clamp(16px, 1.2vw, 28px)'),
    },
  },

  title: {
    fontWeight: 600,
    fontSize: fontScale.heading,
    lineHeight: '1.25',
    color: tokens.colorNeutralForegroundOnBrand,
    maxWidth: '430px',
    margin: '0',
    [mq.ultraWideUp]: {
      fontSize: fontScale.heading,
      maxWidth: '600px',
    },
  },

  description: {
    fontWeight: 400,
    fontSize: fontScale.subtitle,
    lineHeight: '1.5',
    color: tokens.colorNeutralForegroundOnBrand,
    maxWidth: '430px',
    margin: '0',
    [mq.ultraWideUp]: {
      maxWidth: '600px',
    },
  },

  button: {
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
    ...shorthands.padding('15px'),
    ...shorthands.borderWidth('1px'),
    ...shorthands.borderStyle('solid'),
    ...shorthands.borderColor(tokens.colorNeutralStroke1),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    alignSelf: 'flex-start',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground3,
      color: tokens.colorNeutralForeground1,
    },
    [mq.ultraWideUp]: {
      ...shorthands.padding('clamp(15px, 1.1vw, 22px)'),
    },
  },
  bookButton: {
    fontSize: fontScale.subtitle + ' !important',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    marginTop: tokens.spacingVerticalL,
  },
  plusGlyph: {
    display: 'inline-block',
    fontSize: '1.4em',
    fontWeight: tokens.fontWeightBold,
    lineHeight: 1,
    marginRight: '0.4em',
    verticalAlign: '-0.05em',
  },
});
